"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapPageElement = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const GatsbyClerkProvider_1 = require("./GatsbyClerkProvider");
const wrapPageElement = ({ element, props }, pluginOptions) => {
    let clerkSsrState;
    if (props.serverData?.clerkState) {
        clerkSsrState = props.serverData.clerkState;
        delete props.serverData.clerkState;
    }
    return (
    // @ts-expect-error
    react_1.default.createElement(GatsbyClerkProvider_1.ClerkProvider, { frontendApi: process.env.GATSBY_CLERK_FRONTEND_API || '', publishableKey: process.env.GATSBY_CLERK_PUBLISHABLE_KEY || '', clerkJSUrl: process.env.GATSBY_CLERK_JS, proxyUrl: process.env.GATSBY_CLERK_PROXY_URL, clerkState: clerkSsrState || {}, ...pluginOptions }, element));
};
exports.wrapPageElement = wrapPageElement;
